module.exports = __webpack_public_path__ + "img/setings_black.799e88a0.svg";